/**
* Generated by Kubb (https://kubb.dev/).
* Do not edit manually.
*/

import fetch from "../../clients/api-v2-client";
import type { Client, RequestConfig, ResponseErrorConfig } from "../../clients/api-v2-client";
import type { AuditMentionsAuditMentionsMatchesCreateManualMutationRequest, AuditMentionsAuditMentionsMatchesCreateManualMutationResponse, AuditMentionsAuditMentionsMatchesCreateManualQueryParams } from "../models/AuditMentionsAuditMentionsMatchesCreateManual";

export function getAuditMentionsAuditMentionsMatchesCreateManualUrl() {
  const res = { method: 'POST', url: `/audit-mentions/v1/matches/create-manual` as const }
  return res
}

/**
 * @description Creates a manual mention match for a station.
 * @summary Create manual mention match
 * {@link /audit-mentions/v1/matches/create-manual}
 */
export async function auditMentionsAuditMentionsMatchesCreateManual(data: AuditMentionsAuditMentionsMatchesCreateManualMutationRequest, params: AuditMentionsAuditMentionsMatchesCreateManualQueryParams, config: Partial<RequestConfig<AuditMentionsAuditMentionsMatchesCreateManualMutationRequest>> & { client?: Client } = {}) {
  const { client: request = fetch, ...requestConfig } = config

  const requestData = data

  const res = await request<AuditMentionsAuditMentionsMatchesCreateManualMutationResponse, ResponseErrorConfig<Error>, AuditMentionsAuditMentionsMatchesCreateManualMutationRequest>({ method : "POST", url : getAuditMentionsAuditMentionsMatchesCreateManualUrl().url.toString(), params, data : requestData, ... requestConfig })
  return res.data
}